<div class="hd-conditioning-info-panel">
  @if (title()) {
    <h2 class="hd-conditioning-info-panel__title">{{ title() }}</h2>
  }
  @if (subtitle()) {
    <p class="hd-conditioning-info-panel__subtitle">{{ subtitle() }}</p>
  }

  <div class="hd-conditioning-info-panel__texts">
    <markdown class="hd-conditioning-md" [src]="impactMarkdownUrl()"></markdown>
    <markdown class="hd-conditioning-md" [src]="terminologyMarkdownUrl()"></markdown>
  </div>

  <div class="hd-conditioning-info-panel__cards">
    @for (center of rankedCenters; track center) {
      <hd-conditioning-card [center]="center" />
    }
  </div>
</div>
